import React from 'react';
import { Link } from '../common/Link';
import { useLocation } from '../../hooks/useLocation';

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

export function NavLink({ href, children, className = '' }: NavLinkProps) {
  const { pathname } = useLocation();
  const isActive = pathname === href;

  return (
    <Link
      href={href}
      className={`transition-colors ${
        isActive ? 'text-primary font-medium' : className || 'text-black hover:text-gray-600'
      }`}
    >
      {children}
    </Link>
  );
}